<template>
  <div>
    <v-footer  color="#FBF9F6">
      <v-col class="text-center text-lg-end fs-14 grey--text text--darken-2" cols="12">
        Copyright ©  {{ (new Date()).getFullYear() }}
        <a target="_blank" class="text-decoration-none"
           href="https://STORE-EXECUTION-dz.com">Store Execution</a>,
        All rights Reserved
      </v-col>
    </v-footer>
  </div>
</template>

<script>
export default {}
</script>

<style scoped>

</style>